module.exports = function (eventName) {
    if (this.debugMode) {
        console.log('%cxhr2:' + '%c' + eventName, 'color: #343434', 'color: #009ACD')
    }
    var event = new CustomEvent('xhr2:' + eventName, { detail: eventName })
    document.dispatchEvent(event)
}



// WEBPACK FOOTER //
// ./core/xhr2/modules/triggerEvent.js